document.addEventListener(
	'alpine:init',
	bootstrap
);

export default () => ({
	partner_type: '',
	init() {
		this.$watch('partner_type', _ => this.partnerTypeChange(_));
	},
	partnerTypeChange(_value) {
		this.$dispatch('show-section', _value);
	}
});

function bootstrap() {
	document.querySelectorAll('.js-partner-section').forEach(
		$section => bootstrapSection($section)
	);
}

function bootstrapSection($section) {
	$section.setAttribute('x-data', '{ visible: false }');
	$section.setAttribute('x-cloak', '');
	$section.setAttribute('x-show', 'visible');
	$section.setAttribute('x-on:show-section.window', 'visible = ($el.attributes.id.value === $event.detail)');
}
